// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__KeTmb","content":"LoadingAlert_content__1NZzz"};